import { z } from 'zod';
import { baseObjectSchema } from '../baseSchemas';
import { traderSchema } from './getTraders';
import { getCompetitorTypeSchema } from './getCompetitorTypes';

export const getCompetitorSchema = baseObjectSchema.extend({
  code: z.string().optional(),
  profession: z.string().optional(),
  remarks: z.string().optional(),
  traderId: z.string(),
  trader: traderSchema,
  competitorTypeId: z.string(),
  competitorType: getCompetitorTypeSchema,
});

export const getCompetitorsSchema = z.array(getCompetitorSchema);

export const getAllCompetitorsSchema = z.array(
  z.object({
    id: z.string(),
    code: z.string(),
    isActive: z.boolean(),
    trader: z.object({
      id: z.string(),
      code: z.string().optional(),
      name: z.string().optional(),
    }),
    competitorType: z.object({
      id: z.string(),
      code: z.string(),
      name: z.string(),
      isActive: z.boolean(),
      isFromManager: z.boolean(),
      deleted: z.boolean(),
    }),
  })
);

export type GetCompetitorsResponse = z.infer<typeof getAllCompetitorsSchema>;
